import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const Auth = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(`${ROUTE_KEYS.AUTH}/${ROUTE_KEYS.LOGIN}`, { replace: true });
  }, []);
  return <div />;
};

export default Auth;
